import { Injectable, NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { appServerResources } from './app server constants';
import { AuthGuard } from './services/auth.guard';

const isProduction = appServerResources.shouldDisableBackButton; // Set this to true for production, false for development

export const AppConfig = {
  // defaultRoute: isProduction == 0 ? 'home' : 'order',
  // defaultRoute: isProduction == 0 ? 'order-source-selection' : 'order-source-selection',

};

const routes: Routes = [
  { path: '', redirectTo: 'location', pathMatch: 'full' },
  { path: 'home', loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)},
  { path: 'home/:id', loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)},
  
  // { path: '', redirectTo:AppConfig.defaultRoute, pathMatch: 'full',canActivate: [AuthGuard]  },

  // { path: '', redirectTo: 'order', pathMatch: 'full' },
  {
    path: 'login',
    redirectTo: 'loginasguest',
    pathMatch: 'full'
  },
  {
    path: 'signup',
    redirectTo: 'loginasguest',
    pathMatch: 'full'
  },
  {
    path: 'location',
    loadChildren: () => import('./location/location.module').then( m => m.LocationPageModule)
  },
  {
    path: 'order',
    loadChildren: () => import('./order/order.module').then( m => m.OrderPageModule),
    data: { shouldReuseRoute: true }
  },
  {
    path: 'payment',
    loadChildren: () => import('./payment/payment.module').then( m => m.PaymentPageModule)
  },
  {
    path: 'order-summary',
    loadChildren: () => import('./order-summary/order-summary.module').then( m => m.OrderSummaryPageModule)
  },
  {
    path: 'checkout',
    loadChildren: () => import('./checkout/checkout.module').then( m => m.CheckoutPageModule)
  },
  {
    path: 'order-detail',
    loadChildren: () => import('./order-detail/order-detail.module').then( m => m.OrderDetailPageModule)
  },
  {
    path: 'arrtibute-selection',
    loadChildren: () => import('./arrtibute-selection/arrtibute-selection.module').then( m => m.ArrtibuteSelectionPageModule)
  },
  {
    path: 'payment-success',
    loadChildren: () => import('./payment-success/payment-success.module').then( m => m.PaymentSuccessPageModule)
  },
  {
    path: 'how-it-works',
    loadChildren: () => import('./how-it-works/how-it-works.module').then( m => m.HowItWorksPageModule)
  },
  {
    path: 'myaccount',
    loadChildren: () => import('./myaccount/myaccount.module').then( m => m.MyaccountPageModule)
  },
  {
    path: 'order-status-track',
    loadChildren: () => import('./order-status-track/order-status-track.module').then( m => m.OrderStatusTrackPageModule)
  },
  {
    path: 'reservationschedule',
    loadChildren: () => import('./reservationschedule/reservationschedule.module').then( m => m.ReservationschedulePageModule)
  },
  {
    path: 'resercationinformation',
    loadChildren: () => import('./resercationinformation/resercationinformation.module').then( m => m.ResercationinformationPageModule)
  },
  {
    path: 'order-history',
    loadChildren: () => import('./order-history/order-history.module').then( m => m.OrderHistoryPageModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./forgotpassword/forgotpassword.module').then( m => m.ForgotpasswordPageModule)
  },
  {
    path: 'customerinfo',
    loadChildren: () => import('./customerinfo/customerinfo.module').then( m => m.CustomerinfoPageModule)
  },
  {
    path: 'reservationlist',
    loadChildren: () => import('./reservationschedule/reservationschedule.module').then( m => m.ReservationschedulePageModule)
  },
  {
    path: 'loginasguest',
    loadChildren: () => import('./loginasguest/loginasguest.module').then( m => m.LoginasguestPageModule)
  },
  {
    path: 'addnewaddress',
    loadChildren: () => import('./addnewaddress/addnewaddress.module').then( m => m.AddnewaddressPageModule)
  },
  {
    path: 'terms-and-conditions',
    loadChildren: () => import('./terms-and-conditions/terms-and-conditions.module').then( m => m.TermsAndConditionsPageModule)
  },
  {
    path: 'address-selection',
    loadChildren: () => import('./address-selection/address-selection.module').then( m => m.AddressSelectionPageModule)
  },
  {
    path: 'order-source-selection',
    loadChildren: () => import('./order-source-selection/order-source-selection.module').then( m => m.OrderSourceSelectionPageModule)
  },
  {
    path: 'reservation-details',
    loadChildren: () => import('./reservation-details/reservation-details.module').then( m => m.ReservationDetailsPageModule)
  },
  {
    path: 'order-track-details',
    loadChildren: () => import('./order-track-details/order-track-details.module').then( m => m.OrderTrackDetailsPageModule)
  },
  {
    path: 'project-plan/:applicationId',
    loadChildren: () => import('./project-plan/project-plan.module').then( m => m.ProjectPlanPageModule)
  },


  // {
  //   path: 'page1',
  //   loadChildren: () => import('./instruction/page1/page1.module').then( m => m.Page1PageModule)
  // },
  // {
  //   path: 'page2',
  //   loadChildren: () => import('./instruction/page2/page2.module').then( m => m.Page2PageModule)
  // },
  // {
  //   path: 'page3',
  //   loadChildren: () => import('./instruction/page3/page3.module').then( m => m.Page3PageModule)
  // }



];

@NgModule({
  imports: [
    // RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
    // RouterModule.forRoot(routes, { useHash: false, initialNavigation: false })
    RouterModule.forRoot(routes, { useHash: false})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
